export default "__VITE_ASSET__YYJ6k2Tq__"